import { JsonObjectType, mapNullable } from 'annotation-tools/utils';
import { envMode } from '../../../../../env-values';
import { HttpMethod } from './types/enum/http-method';
import { HttpStatusCode } from './types/enum/http-status-code';
import { FetchRawResultType } from './types/fetch-raw-result-type';

// CSRFトークンを取得する関数
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

export const fetchJson = async ({
  uri,
  method,
  body: bodyOrNull,
  token: tokenOrNull
}: Readonly<{
  uri: string;
  method: HttpMethod;
  body?: object;
  token?: string;
}>): Promise<FetchRawResultType> => {
  const requestHeaders: any = {
    'Content-Type': 'application/json'
  };
  
  // ログインエンドポイント以外の場合のみCSRFトークンを追加
  // ログインエンドポイントはCSRF免除されているため
  if (!uri.includes('/api/auth/login/')) {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
      requestHeaders['X-CSRFToken'] = csrfToken;
    }
  }
  
  // 認証トークンがあれば追加
  if (tokenOrNull !== undefined) {
    requestHeaders['Authorization'] = `Bearer ${tokenOrNull}`;
  }

  const body = mapNullable(bodyOrNull, obj => JSON.stringify(obj));

  const result = await fetch(uri, {
    method,
    headers: requestHeaders,
    body,
    credentials: 'include' // cookieを含めるように設定
  }).catch(reason => {
    if (envMode !== 'production') {
      console.log(reason);
    }
    return 'error' as const;
  });

  if (result === 'error') {
    return {
      type: 'error',
      statusCode: undefined,
      body: {},
      headers: new Headers()
    };
  }

  const statusCode = result.status as HttpStatusCode;
  const responseHeaders: Headers = result.headers;
  const responseText: string = await result.text();
  const responseBody: JsonObjectType =
    responseText === '' ? {} : JSON.parse(responseText);

  if (!result.ok && envMode !== 'production') {
    console.log(
      `Network response was not ok. (status code = ${statusCode}, body: ${responseText})`
    );
  }

  return {
    type: result.ok ? 'success' : 'error',
    statusCode,
    body: responseBody,
    headers: responseHeaders
  };
};
